const hasIgnoredElements = path => {
  if (!ignoredElements.length || !path) return false

  for (let i = 0, len = ignoredElements.length; i < len; i++) {
    try {
      for (let pathIndex = 0; pathIndex < path.length; pathIndex++) {
        const classList = path[pathIndex].classList
        if (
          ignoredElements[i] === path[pathIndex] ||
          classList.contains('v-menu__content') ||
          classList.contains('v-dialog--active') ||
          classList.contains('pswp--open')
        ) {
          return true
        }
      }
    } catch (e) {
      return false
    }
  }

  return false
}

const ignoredElements = []

const addClickOutsideListener = (el, binding, vnode) => {
  let install = true
  if (binding.arg) {
    install = vnode.context[binding.arg]
  }

  if (install && !el.clickOutsideEvent) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (event && !(el === event.target || el.contains(event.target)) && !hasIgnoredElements(event.path)) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('mousedown', el.clickOutsideEvent)
  } else if (!install && el.clickOutsideEvent) {
    document.body.removeEventListener('mousedown', el.clickOutsideEvent)
    el.clickOutsideEvent = null
  }
}

export default {
  install(Vue) {
    Vue.directive('reg-click-outside', {
      bind: addClickOutsideListener,
      componentUpdated: addClickOutsideListener,
      unbind: function (el) {
        if (el.clickOutsideEvent) {
          document.body.removeEventListener('mousedown', el.clickOutsideEvent)
          el.clickOutsideEvent = null
        }
      }
    })

    Vue.directive('reg-ignore-click-outside', {
      bind: function (el) {
        ignoredElements.push(el)
      },
      unbind: function (el) {
        for (let index = 0; index < ignoredElements.length; index++) {
          if (el === ignoredElements[index]) {
            ignoredElements.splice(index, 1)
            return
          }
        }
      }
    })
  }
}
